const FormHeader = ({ selectedModel }) => {
    // Va a la ficha del modelo. No usar window.history.back(): si se llegó al
    // configurador desde una campaña externa (ej. un anuncio de Google), el
    // historial no tiene la ficha del modelo y el botón sacaría al usuario
    // del sitio en vez de dejarlo "siguiendo viendo el modelo".
    const handleBack = () => {
        if (selectedModel.model_page) {
            window.location.href = selectedModel.model_page;
        }
    };

    return (
        <>
            <div className="modal-box__back">
                <button type="button" onClick={handleBack}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 13L5.5 8L10.5 3" stroke="#161616" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Seguir viendo el modelo</span>
                </button>
            </div>
            <div className="modal-box__header">
                <h2>Cotiza tu {selectedModel.name}</h2>
                <p>Ingresa tus datos para continuar con la cotización</p>
            </div>
            {selectedModel.image ? (
                <div className="modal-box__model">
                    <img
                        src={selectedModel.image.url}
                        alt={selectedModel.image.alt || selectedModel.name}
                    />
                    <div className="modal-box__model__tag">
                        <span>Estás cotizando</span>
                        <p>{selectedModel.name}</p>
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default FormHeader;
